module.exports = __webpack_public_path__ + "img/47.1bcd455a.png";